// extracted by mini-css-extract-plugin
module.exports = {"amazonAffiliateInfo":"amazon-affiliate-info-module--amazon-affiliate-info--1OGOo"};